import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {spacing} from '../../../styles/js/variables';

const styles = {
  calculatorForm: css`
    label: calculatorForm;

    .radioIconField {
      flex-wrap: wrap;
    }
  `,
  // @todo: remove important once RadioIconField is refactored to emotion
  radioField: css`
    label: calculatorForm__radioField;
    flex-basis: unset;
    flex: 0 1 31%;
    margin-bottom: ${spacing.XXS} !important;

    ${mq(Breakpoints.TABLET)} {
      flex: 0 1 16%;
    }

    ${mq(Breakpoints.DESKTOP)} {
      margin-bottom: 0;
    }
  `,
};

export default styles;
